import cx from 'classnames'
import { useState } from 'react'
import { FaUndo } from 'react-icons/fa'

const KitAlreadyRegistered = ({
  kitId,
  onContinue,
  onRestart,
  sku,
}: {
  kitId: string
  onContinue: () => Promise<void>
  onRestart: () => void
  sku: string
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const onSubmit = async () => {
    try {
      setIsSubmitting(true)
      await onContinue()
    } finally {
      setIsSubmitting(false)
    }
  }

  const isAntigen = ['rapid_travel', 'rapid_travel_hughes'].includes(sku)

  return (
    <div>
      <h1 className="title is-spaced has-text-midnightBlue">
        Kit <span className="is-family-monospace has-text-weight-light">{kitId}</span>
        {isAntigen ? <> - We're Analysing Your Result</> : <> - This Kit is Already Registered</>}
      </h1>

      {isAntigen && <p>We have your rapid antigen test submission and are reviewing it now.</p>}

      <p className="mt-4">
        Do you need to update the details that you registered for this kit? Click &lsquo;Yes&rsquo; if you entered some
        details incorrectly, or if one of our support team asked you to change your details.
      </p>

      <div className="buttons is-right mt-4">
        <button
          className={cx('button is-midnightBlue', {
            'is-loading': isSubmitting,
          })}
          disabled={isSubmitting}
          onClick={onSubmit}
        >
          <strong>Yes</strong>&nbsp;- change details for Kit {kitId}
        </button>
      </div>

      <hr />

      <p className="mt-3">
        <button className="button is-text pl-0 is-size-7" onClick={onRestart}>
          <div className="is-flex is-align-items-center">
            <FaUndo className="mr-2" /> Start over with another kit ID
          </div>
        </button>
      </p>
    </div>
  )
}

export default KitAlreadyRegistered
